import React from 'react';

import { Box, Typography, useTheme, styled } from '@mui/material';

import ChevronTopIcon from '~/assets/icons/ChevronTopIcon';
import Checkbox from '~/components/Checkbox/Checkbox';
import { css, CssUtilityType } from '~/styled';
import { SMALL_MARGIN_PX } from '~/theme';

interface FilterItemProps {
  label: string;
  count: number;
  isRefined: boolean;
  value: any;
  refine: Function;
  filterValue: string;
  withArrow?: boolean;
}

const FilterItem: React.FC<FilterItemProps> = React.forwardRef(
  (
    { label, count, isRefined, value, refine, filterValue, withArrow = false },
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const theme = useTheme();
    const checkboxName = `${filterValue}${label}`
      ?.replaceAll(' ', '_')
      .replaceAll(/[^a-zA-Z0-9\s]/g, '');

    return (
      <ListItem
        data-testid="filterItem"
        ref={ref}
        onClick={() => refine(value)}
        optionalStyles={isRefined ? generatedListItemActive : undefined}
      >
        <LeftPart>
          {withArrow && (
            <Icon
              color={theme.palette.common.white}
              optionalStyles={isRefined && generatedSelectedIcon}
            />
          )}
          <StyledCheckbox checked={isRefined} onChange={() => refine(value)} name={checkboxName}>
            {label}
          </StyledCheckbox>
        </LeftPart>
        <Box>
          <ListItemCount className="listItemCount">({count})</ListItemCount>
        </Box>
      </ListItem>
    );
  },
);

export default FilterItem;

const ListItem = styled('div', {
  shouldForwardProp: (prop) => prop !== 'optionalStyles',
})<{ optionalStyles?: CssUtilityType }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  cursor: pointer;

  ${({ optionalStyles }) => optionalStyles}
`;
const generatedListItemActive = ({ theme }) => css`
  & .listItemTitle {
    color: ${theme.palette.common.white};
  }

  & .listItemCount {
    opacity: 1;
  }
`;
const LeftPart = styled(Box)`
  display: flex;
  align-items: center;
`;
const Icon = styled(ChevronTopIcon, {
  shouldForwardProp: (prop) => prop !== 'optionalStyles',
})`
  width: 16px;
  height: 16px;
  cursor: pointer;
  transform: rotate(180deg);
  transition: transform 0.3s ease-out;
  margin-right: ${SMALL_MARGIN_PX};
  flex-shrink: 0;

  ${({ optionalStyles }) => optionalStyles}
`;
const generatedSelectedIcon = css`
  transform: none;
`;
const ListItemCount = styled(Typography)`
  font-size: 11px;
  line-height: 1.2;
  color: ${({ theme }) => theme.palette.common.white};
  opacity: 0.5;
  margin-bottom: 0;
`;
const StyledCheckbox = styled(Checkbox)`
  & label::before {
    margin-right: ${SMALL_MARGIN_PX};
  }
`;
